import { Fragment } from 'react';
import { s } from '../lib/style.js';

export function Ecosystem({ v }) {
  return (
    <section style={s("scroll-margin-top:80px;border-top:1px solid var(--line);")}>
      <div
        style={s("max-width:1000px;margin:0 auto;padding:clamp(64px,9vw,120px) clamp(20px,4vw,28px);text-align:center;")}
      >
        <div
          style={s("display:inline-flex;align-items:center;margin-bottom:18px;padding:9px 20px;border-radius:999px;background:#FFFFFF;border:1px solid rgba(18,49,56,0.12);box-shadow:0 2px 10px rgba(18,49,56,0.06);font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
        >
          Ecosystem strategy
        </div>
        <h2
          style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(30px,4vw,50px);line-height:1.08;letter-spacing:-0.03em;margin:0;color:var(--text);")}
        >
          It works with what you already use and it
          {' '}
          <span style={s(v.kwLight)}>
            grows with you.
          </span>
        </h2>
        <p style={s("max-width:620px;margin:20px auto 0;font-size:18px;line-height:1.65;color:var(--muted);")}>
          BrandBase is MCP-ready. It connects your data and the AI tools your teams already run, so the value compounds instead of forcing a rip-and-replace.
        </p>
        <div
          style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(210px,100%),1fr));gap:16px;max-width:800px;margin:44px auto 0;")}
        >
          <div
            className="hv-8"
            style={s("display:flex;flex-direction:column;border:1px solid var(--line);border-radius:18px;padding:26px 24px;background:#FFFFFF;box-shadow:0 14px 34px rgba(18,49,56,0.05);text-align:left;transition:transform .35s cubic-bezier(.4,0,.2,1),box-shadow .35s ease;")}
          >
            <div style={s("display:flex;align-items:center;justify-content:space-between;gap:12px;")}>
              {' '}
              <span
                aria-hidden="true"
                style={s("display:flex;align-items:center;justify-content:center;width:42px;height:42px;border-radius:13px;background:linear-gradient(150deg,#5B9A96 0%,#1B4A48 100%);box-shadow:0 8px 20px rgba(18,49,56,0.28);color:#EAF3F1;")}
              >
                {' '}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                >
                  <path d="M6 12h12M12 6v12" strokeLinecap="round" />
                  <circle cx="6" cy="12" r="2.4" />
                  <circle cx="18" cy="12" r="2.4" />
                  <circle cx="12" cy="5" r="2.4" />
                  <circle cx="12" cy="19" r="2.4" />
                </svg>
                {' '}
              </span>
              {' '}
            </div>
            <div style={s("display:flex;align-items:baseline;gap:12px;margin-top:22px;")}>
              {' '}
              <span
                style={s(`font-family:'Sofia Pro',sans-serif;font-size:clamp(38px,4vw,48px);font-weight:500;line-height:1;letter-spacing:-0.04em;${v.kwLight ?? ""}`)}
              >
                MCP
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
              >
                protocol
              </span>
              {' '}
            </div>
            <div
              style={s("margin-top:14px;padding-top:14px;border-top:1px solid var(--line);font-size:15.5px;line-height:1.55;color:var(--muted);text-wrap:pretty;")}
            >
              Ready out of the box, so your agents and ours share the same surface.
            </div>
          </div>
          <div
            className="hv-8"
            style={s("display:flex;flex-direction:column;border:1px solid var(--line);border-radius:18px;padding:26px 24px;background:#FFFFFF;box-shadow:0 14px 34px rgba(18,49,56,0.05);text-align:left;transition:transform .35s cubic-bezier(.4,0,.2,1),box-shadow .35s ease;")}
          >
            <div style={s("display:flex;align-items:center;justify-content:space-between;gap:12px;")}>
              {' '}
              <span
                aria-hidden="true"
                style={s("display:flex;align-items:center;justify-content:center;width:42px;height:42px;border-radius:13px;background:linear-gradient(150deg,#5B9A96 0%,#1B4A48 100%);box-shadow:0 8px 20px rgba(18,49,56,0.28);color:#EAF3F1;")}
              >
                {' '}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                >
                  <path d="M4 12h5m6 0h5" strokeLinecap="round" />
                  <rect x="9" y="7" width="6" height="10" rx="2" />
                </svg>
                {' '}
              </span>
              {' '}
            </div>
            <div style={s("display:flex;align-items:baseline;gap:12px;margin-top:22px;")}>
              {' '}
              <span
                style={s(`font-family:'Sofia Pro',sans-serif;font-size:clamp(38px,4vw,48px);font-weight:500;line-height:1;letter-spacing:-0.04em;${v.kwLight ?? ""}`)}
              >
                12+
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
              >
                connectors
              </span>
              {' '}
            </div>
            <div
              style={s("margin-top:14px;padding-top:14px;border-top:1px solid var(--line);font-size:15.5px;line-height:1.55;color:var(--muted);text-wrap:pretty;")}
            >
              Data and workflow connectors at launch, with more added per partner.
            </div>
          </div>
          <div
            className="hv-8"
            style={s("display:flex;flex-direction:column;border:1px solid var(--line);border-radius:18px;padding:26px 24px;background:#FFFFFF;box-shadow:0 14px 34px rgba(18,49,56,0.05);text-align:left;transition:transform .35s cubic-bezier(.4,0,.2,1),box-shadow .35s ease;")}
          >
            <div style={s("display:flex;align-items:center;justify-content:space-between;gap:12px;")}>
              {' '}
              <span
                aria-hidden="true"
                style={s("display:flex;align-items:center;justify-content:center;width:42px;height:42px;border-radius:13px;background:linear-gradient(150deg,#5B9A96 0%,#1B4A48 100%);box-shadow:0 8px 20px rgba(18,49,56,0.28);color:#EAF3F1;")}
              >
                {' '}
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                >
                  <path d="M12 4 4 8.5l8 4.5 8-4.5L12 4Z" />
                  <path d="M4 14l8 4.5 8-4.5" strokeLinecap="round" />
                </svg>
                {' '}
              </span>
              {' '}
            </div>
            <div style={s("display:flex;align-items:baseline;gap:12px;margin-top:22px;")}>
              {' '}
              <span
                style={s(`font-family:'Sofia Pro',sans-serif;font-size:clamp(38px,4vw,48px);font-weight:500;line-height:1;letter-spacing:-0.04em;${v.kwLight ?? ""}`)}
              >
                1
              </span>
              {' '}
              <span
                style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10px;letter-spacing:0.14em;text-transform:uppercase;color:var(--mint);")}
              >
                foundation
              </span>
              {' '}
            </div>
            <div
              style={s("margin-top:14px;padding-top:14px;border-top:1px solid var(--line);font-size:15.5px;line-height:1.55;color:var(--muted);text-wrap:pretty;")}
            >
              Foundation beneath every team, agency, and tool in your stack.
            </div>
          </div>
        </div>
        <div style={s("position:relative;margin:clamp(24px,4vw,42px) -28px 0;")}>
          <div
            style={s("position:relative;overflow:hidden;padding:16px 0 22px;display:flex;flex-direction:column;gap:14px;-webkit-mask-image:linear-gradient(90deg,transparent,#000 12%,#000 88%,transparent);mask-image:linear-gradient(90deg,transparent,#000 12%,#000 88%,transparent);")}
          >
            <div
              className="hv-9"
              style={s("display:flex;width:max-content;gap:14px;padding:0 7px;animation:bb-marquee 42s linear infinite;")}
            >
              <div style={s("display:flex;gap:14px;")}>
                {(v.ecoRowA ?? []).map((c, i) => (
                  <Fragment key={i}>
                    <div
                      className="hv-10"
                      style={s("display:flex;align-items:center;gap:12px;border:1px solid rgba(18,49,56,0.12);border-radius:14px;padding:14px 22px;background:#FFFFFF;white-space:nowrap;box-shadow:0 6px 18px rgba(18,49,56,0.07);transition:border-color .25s ease, transform .25s ease, box-shadow .25s ease;")}
                    >
                      {c.logo ? (
                        <>
                          {' '}
                          <span
                            style={s(`width:24px;height:24px;background:url(${c.logo ?? ""}) center/contain no-repeat;flex:0 0 auto;opacity:.9;`)}
                          />
                          {' '}
                        </>
                      ) : null}
                      {' '}
                      <span
                        style={s("font-family:'Sofia Pro',sans-serif;font-size:17px;font-weight:600;letter-spacing:-0.015em;color:#12262A;")}
                      >
                        {c.name}
                      </span>
                      {' '}
                    </div>
                  </Fragment>
                ))}
              </div>
              <div aria-hidden="true" style={s("display:flex;gap:14px;")}>
                {(v.ecoRowA ?? []).map((c, i) => (
                  <Fragment key={i}>
                    <div
                      className="hv-10"
                      style={s("display:flex;align-items:center;gap:12px;border:1px solid rgba(18,49,56,0.12);border-radius:14px;padding:14px 22px;background:#FFFFFF;white-space:nowrap;box-shadow:0 6px 18px rgba(18,49,56,0.07);transition:border-color .25s ease, transform .25s ease, box-shadow .25s ease;")}
                    >
                      {c.logo ? (
                        <>
                          {' '}
                          <span
                            style={s(`width:24px;height:24px;background:url(${c.logo ?? ""}) center/contain no-repeat;flex:0 0 auto;opacity:.9;`)}
                          />
                          {' '}
                        </>
                      ) : null}
                      {' '}
                      <span
                        style={s("font-family:'Sofia Pro',sans-serif;font-size:17px;font-weight:600;letter-spacing:-0.015em;color:#12262A;")}
                      >
                        {c.name}
                      </span>
                      {' '}
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
            <div
              className="hv-9"
              style={s("display:flex;width:max-content;gap:14px;padding:0 7px;animation:bb-marquee-rev 52s linear infinite;")}
            >
              <div style={s("display:flex;gap:14px;")}>
                {(v.ecoRowB ?? []).map((c, i) => (
                  <Fragment key={i}>
                    <div
                      className="hv-10"
                      style={s("display:flex;align-items:center;gap:12px;border:1px solid rgba(18,49,56,0.12);border-radius:14px;padding:14px 22px;background:#FFFFFF;white-space:nowrap;box-shadow:0 6px 18px rgba(18,49,56,0.07);transition:border-color .25s ease, transform .25s ease, box-shadow .25s ease;")}
                    >
                      {c.logo ? (
                        <>
                          {' '}
                          <span
                            style={s(`width:24px;height:24px;background:url(${c.logo ?? ""}) center/contain no-repeat;flex:0 0 auto;opacity:.9;`)}
                          />
                          {' '}
                        </>
                      ) : null}
                      {' '}
                      <span
                        style={s("font-family:'Sofia Pro',sans-serif;font-size:17px;font-weight:600;letter-spacing:-0.015em;color:#12262A;")}
                      >
                        {c.name}
                      </span>
                      {' '}
                    </div>
                  </Fragment>
                ))}
              </div>
              <div aria-hidden="true" style={s("display:flex;gap:14px;")}>
                {(v.ecoRowB ?? []).map((c, i) => (
                  <Fragment key={i}>
                    <div
                      className="hv-10"
                      style={s("display:flex;align-items:center;gap:12px;border:1px solid rgba(18,49,56,0.12);border-radius:14px;padding:14px 22px;background:#FFFFFF;white-space:nowrap;box-shadow:0 6px 18px rgba(18,49,56,0.07);transition:border-color .25s ease, transform .25s ease, box-shadow .25s ease;")}
                    >
                      {c.logo ? (
                        <>
                          {' '}
                          <span
                            style={s(`width:24px;height:24px;background:url(${c.logo ?? ""}) center/contain no-repeat;flex:0 0 auto;opacity:.9;`)}
                          />
                          {' '}
                        </>
                      ) : null}
                      {' '}
                      <span
                        style={s("font-family:'Sofia Pro',sans-serif;font-size:17px;font-weight:600;letter-spacing:-0.015em;color:#12262A;")}
                      >
                        {c.name}
                      </span>
                      {' '}
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
            <div
              className="hv-9"
              style={s("display:flex;width:max-content;gap:14px;padding:0 7px;animation:bb-marquee 46s linear infinite;")}
            >
              <div style={s("display:flex;gap:14px;")}>
                {(v.ecoRowC ?? []).map((c, i) => (
                  <Fragment key={i}>
                    <div
                      className="hv-10"
                      style={s("display:flex;align-items:center;gap:12px;border:1px solid rgba(18,49,56,0.12);border-radius:14px;padding:14px 22px;background:#FFFFFF;white-space:nowrap;box-shadow:0 6px 18px rgba(18,49,56,0.07);transition:border-color .25s ease, transform .25s ease, box-shadow .25s ease;")}
                    >
                      {c.logo ? (
                        <>
                          {' '}
                          <span
                            style={s(`width:24px;height:24px;background:url(${c.logo ?? ""}) center/contain no-repeat;flex:0 0 auto;opacity:.9;`)}
                          />
                          {' '}
                        </>
                      ) : null}
                      {' '}
                      <span
                        style={s("font-family:'Sofia Pro',sans-serif;font-size:17px;font-weight:600;letter-spacing:-0.015em;color:#12262A;")}
                      >
                        {c.name}
                      </span>
                      {' '}
                    </div>
                  </Fragment>
                ))}
              </div>
              <div aria-hidden="true" style={s("display:flex;gap:14px;")}>
                {(v.ecoRowC ?? []).map((c, i) => (
                  <Fragment key={i}>
                    <div
                      className="hv-10"
                      style={s("display:flex;align-items:center;gap:12px;border:1px solid rgba(18,49,56,0.12);border-radius:14px;padding:14px 22px;background:#FFFFFF;white-space:nowrap;box-shadow:0 6px 18px rgba(18,49,56,0.07);transition:border-color .25s ease, transform .25s ease, box-shadow .25s ease;")}
                    >
                      {c.logo ? (
                        <>
                          {' '}
                          <span
                            style={s(`width:24px;height:24px;background:url(${c.logo ?? ""}) center/contain no-repeat;flex:0 0 auto;opacity:.9;`)}
                          />
                          {' '}
                        </>
                      ) : null}
                      {' '}
                      <span
                        style={s("font-family:'Sofia Pro',sans-serif;font-size:17px;font-weight:600;letter-spacing:-0.015em;color:#12262A;")}
                      >
                        {c.name}
                      </span>
                      {' '}
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
          <div
            aria-hidden="true"
            style={s("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2;display:flex;align-items:center;justify-content:center;height:calc(50%);padding:0 44px;border-radius:22px;background:rgba(255,255,255,0.62);backdrop-filter:blur(5px) saturate(1.15);-webkit-backdrop-filter:blur(5px) saturate(1.15);border:1px solid rgba(46,122,114,0.22);box-shadow:0 18px 44px rgba(18,49,56,0.10);")}
          >
            {' '}
            <img src="/assets/brandbase-logo.webp" alt="BrandBase" style={s("height:30px;display:block;")} />
            {' '}
          </div>
        </div>
        <p
          style={s("max-width:620px;margin:28px auto 0;font-size:16px;line-height:1.6;color:var(--muted);opacity:.8;")}
        >
          The more of your stack that lives here, the more value you'll get on day one — and the better a design-partner fit.
        </p>
      </div>
    </section>
  );
}
